export default "__VITE_ASSET__CC5vsK5X__"